import React from "react";
import CardIcon from "../Images/cc-logo.svg";
import AchIcon from "../Images/ach-logo.svg";
import SelectedAchIcon from "../Images/ach-logo-blue.svg";
import SelectedCardIcon from "../Images/cc-logo-blue.svg";
import { myUtilities } from "../Utils";

const PaymentMethodButton = ({ type, callBack, selectedPaymentMethod }) => {
  const payMethodsNames = {
    ach: myUtilities.accountSpecificLanguage(
      "paymentmethods.ach",
      "Bank Account"
    ),
    cc: myUtilities.accountSpecificLanguage(
      "paymentmethods.creditcard",
      "Credit Card"
    ),
    dc: myUtilities.accountSpecificLanguage(
      "paymentmethods.debitCard",
      "Debit Card"
    ),
  };

  const payMethodsIcons = {
    achfalse: AchIcon,
    ccfalse: CardIcon,
    dcfalse: CardIcon,
    achtrue: SelectedAchIcon,
    cctrue: SelectedCardIcon,
    dctrue: SelectedCardIcon,
  };
  const isSelected = selectedPaymentMethod === type;
  return (
    <button
      onClick={() => callBack(type)}
      className={`payment-type-button  sel-${isSelected}`}
    >
      <img src={payMethodsIcons[type + isSelected]} alt="pay-icon" />
      {payMethodsNames[type]}
    </button>
  );
};

export default PaymentMethodButton;
